// Shared constants for construction planning
// Order matches database construction_stages.display_order

export const CONSTRUCTION_STAGES: Record<string, { order: number; color: string }> = {
  // Site & Foundation (1-10)
  'Site Preparation': { order: 1, color: 'bg-orange-100 text-orange-800' },
  'Demolition & Dismantling': { order: 2, color: 'bg-gray-100 text-gray-800' },
  'Earthwork': { order: 3, color: 'bg-amber-100 text-amber-800' },
  
  // Structure (10-20)
  'RCC': { order: 10, color: 'bg-red-100 text-red-800' },
  'Scaffolding': { order: 15, color: 'bg-stone-100 text-stone-800' },
  
  // Masonry & MEP Rough-in (20-40)
  'Masonry': { order: 20, color: 'bg-orange-100 text-orange-800' },
  'Plumbing': { order: 25, color: 'bg-blue-100 text-blue-800' },
  'Electrical': { order: 30, color: 'bg-yellow-100 text-yellow-800' },
  'Waterproofing': { order: 35, color: 'bg-cyan-100 text-cyan-800' },
  
  // Finishing - Interior (40-60)
  'Plaster Internal': { order: 40, color: 'bg-pink-100 text-pink-800' },
  'Flooring & Tiling': { order: 45, color: 'bg-purple-100 text-purple-800' },
  'False Ceiling': { order: 50, color: 'bg-teal-100 text-teal-800' },
  'Painting Internal': { order: 55, color: 'bg-rose-100 text-rose-800' },
  
  // Finishing - Exterior (60-70)
  'External Plaster': { order: 60, color: 'bg-slate-100 text-slate-800' },
  'Painting External': { order: 65, color: 'bg-lime-100 text-lime-800' },
  
  // Doors, Windows, Fixtures (70-80)
  'Doors & Windows': { order: 70, color: 'bg-indigo-100 text-indigo-800' },
  'Fabrication': { order: 75, color: 'bg-zinc-100 text-zinc-800' },
  
  // Final (80-90)
  'Services/Utilities': { order: 80, color: 'bg-emerald-100 text-emerald-800' },
  'Painting': { order: 85, color: 'bg-fuchsia-100 text-fuchsia-800' },
  
  // Admin/Other (90+)
  'Departmental': { order: 90, color: 'bg-violet-100 text-violet-800' },
  'Overheads': { order: 95, color: 'bg-gray-100 text-gray-800' },
};

// Helper to get sorted stage names
export const getSortedStages = (): string[] => {
  return Object.entries(CONSTRUCTION_STAGES)
    .sort((a, b) => a[1].order - b[1].order)
    .map(([name]) => name);
};

// Helper to get stage color
export const getStageColor = (stage: string): string => {
  return CONSTRUCTION_STAGES[stage]?.color || 'bg-gray-100 text-gray-800';
};

// Helper to get stage order
export const getStageOrder = (stage: string): number => {
  return CONSTRUCTION_STAGES[stage]?.order || 999;
};
